var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplanes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 90,
    viewBox: "0 0 170 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.476 66.3818C139.852 66.3818 164.476 60.3377 164.476 52.8818C164.476 45.426 139.852 39.3818 109.476 39.3818C79.1005 39.3818 54.4761 45.426 54.4761 52.8819C54.4761 60.3377 79.1005 66.3818 109.476 66.3818Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.576 28.2054L65.6981 34.9436L145.972 39.1602L155.982 53.4374L151.576 28.2054Z",
    fill: "#BEB58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.982 53.4374L140.368 50.1148L145.972 39.1602L155.982 53.4374Z",
    fill: "#716B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.202 12.8404L71.9148 33.9545L151.264 27.7282L159.202 12.8404Z",
    fill: "#EEECDB",
    stroke: "#BEB58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6315 35.5988L133.709 62.0973L145.176 39.6188L68.6315 35.5988Z",
    fill: "#EEECDB",
    stroke: "#BEB58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.669 28.8214C138.412 24.3917 133.964 24.0502 127.297 24.5812C121.935 25.0083 116.679 27.3353 114.691 31.1047L142.669 28.8214Z",
    fill: "#FFD84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.987 39.0996C145.374 36.9391 145.266 35.8127 144.905 33.5114C144.65 31.8892 143.26 29.4356 142.669 28.8214L114.691 31.1047C114.331 33.1182 114.644 36.2743 115.432 37.5517L144.987 39.0996Z",
    fill: "#C5992A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.239 23.7757L143.923 17.4543",
    stroke: "#FFCD4E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.493 26.876L150.487 24.9268",
    stroke: "#FFCD4E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.774 26.5983L114.781 28.5137",
    stroke: "#FFCD4E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.413 22.8591L121.617 24.6415",
    stroke: "#FFCD4E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.184 20.9524L130.165 23.1699",
    stroke: "#FFCD4E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.248 54.6096C127.553 54.4501 127.341 55.3772 128.035 55.5367C128.783 55.4644 128.943 54.7691 128.248 54.6096Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.289 47.812C135.594 47.6525 135.328 48.8113 136.023 48.9708C136.771 48.8985 136.984 47.9715 136.289 47.812Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.505 21.2813C150.779 21.3672 151.206 22.1296 151.932 22.0437C152.572 21.8053 152.231 21.1954 151.505 21.2813Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.601 46.8708C126.37 46.8176 126.37 46.8176 126.601 46.8708C125.515 47.3534 126.514 48.3145 127.137 47.7256C127.137 47.7256 127.19 47.4938 127.421 47.5469C127.991 47.1897 126.939 46.4604 126.601 46.8708Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.262 23.9218C144.02 23.9504 144.02 23.9504 144.262 23.9218C143.55 24.4938 145.016 24.808 145.244 24.2933C145.244 24.2933 145.159 24.1408 145.401 24.1122C145.714 23.7499 144.333 23.5882 144.262 23.9218Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07 41.6713C117.839 41.6182 117.839 41.6182 118.07 41.6713C116.984 42.154 117.983 43.115 118.605 42.5261C118.605 42.5261 118.659 42.2943 118.89 42.3475C119.46 41.9903 118.408 41.261 118.07 41.6713Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.849 20.6383C133.607 20.667 133.607 20.667 133.849 20.6383C133.137 21.2103 134.603 21.5246 134.831 21.0099C134.831 21.0099 134.746 20.8574 134.988 20.8287C135.301 20.4665 133.92 20.3047 133.849 20.6383Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.966 41.2158C101.734 41.1626 101.734 41.1626 101.966 41.2158C100.88 41.6984 101.878 42.6595 102.501 42.0705C102.501 42.0705 102.554 41.8387 102.786 41.8919C103.355 41.5347 102.304 40.8054 101.966 41.2158Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.463 41.5708C136.231 41.5176 136.231 41.5176 136.463 41.5708C135.377 42.0534 136.375 43.0145 136.998 42.4255C136.998 42.4255 137.051 42.1937 137.283 42.2469C137.852 41.8897 136.801 41.1604 136.463 41.5708Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.057 17.5048C147.815 17.5334 147.815 17.5334 148.057 17.5048C147.346 18.0768 148.811 18.391 149.039 17.8763C149.039 17.8763 148.954 17.7238 149.196 17.6952C149.509 17.3329 148.128 17.1712 148.057 17.5048Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.699 47.7278C114.004 47.5683 113.792 48.4953 114.486 48.6548C115.181 48.8143 115.394 47.8873 114.699 47.7278Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6281 39.262C88.9334 39.1025 88.7206 40.0295 89.4153 40.189C90.11 40.3485 90.3228 39.4214 89.6281 39.262Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5505 29.5647C98.8247 29.6506 99.1661 30.2606 99.892 30.1747C100.618 30.0887 100.276 29.4788 99.5505 29.5647Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2309 80.8647C92.6066 80.8647 117.231 74.8206 117.231 67.3648C117.231 59.9089 92.6066 53.8647 62.2309 53.8647C31.8553 53.8647 7.23093 59.9089 7.23093 67.3648C7.23093 74.8206 31.8553 80.8647 62.2309 80.8647Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5351 37.2805L5.23155 61.4044L93.5661 50.3178L107.269 63.9263L97.5351 37.2805Z",
    fill: "#BEB58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.269 63.9263L89.5972 63.3549L93.5661 50.3178L107.269 63.9263Z",
    fill: "#716B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.859 13.377L9.97298 59.6486L97.1451 36.8654L104.859 13.377Z",
    fill: "#EEECDB",
    stroke: "#BEB58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23499 61.5319L84.7172 77.7814L92.8647 50.9095L8.23499 61.5319Z",
    fill: "#EEECDB",
    stroke: "#BEB58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0736 56.4083C45.7028 62.5263 53.3785 67.7941 62.7635 68.1362C77.1349 68.66 83.6767 60.0226 83.6767 51.5529L45.0736 56.4083Z",
    fill: "#FFD84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4068 67.1559L83.8001 73.9995",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1486 55.8631L89.9769 56.0845",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5339 61.0989L41.3312 59.1007",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4135 69.3888L61.2711 71.7669",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8942 64.7191L43.7743 67.9313",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4481 40.4406C80.3764 35.8742 72.8105 37.1849 65.6468 39.0662C59.8843 40.5795 48.4779 45.9813 47.0476 50.4789L85.4481 40.4406Z",
    fill: "#FFD84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4481 51.3277C86.2601 49.4455 86.3892 43.7251 85.4481 40.4406L47.0476 50.4789C46.5993 52.4391 46.6904 54.9771 47.0474 56.1501L85.4481 51.3277Z",
    fill: "#C5992A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6433 35.2392L87.222 27.0553",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3057 44.5522L47.7771 46.2079",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2362 38.7246L56.3661 40.3602",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4915 33.2474L68.467 35.7032",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1045 29.746C95.33 29.9815 95.9443 30.7293 96.7188 30.4938C97.3705 30.1088 96.879 29.5105 96.1045 29.746Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6886 28.0807C80.3348 28.1883 80.6154 28.5299 80.9692 28.4223C81.2669 28.2464 81.0424 27.9731 80.6886 28.0807Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7983 61.4342C85.0237 61.6697 85.638 62.4175 86.4125 62.182C87.0642 61.797 86.5728 61.1988 85.7983 61.4342Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0658 34.9499C89.8076 35.0284 89.8076 35.0284 90.0658 34.9499C89.4016 35.7125 91.0611 35.7687 91.2089 35.163C91.2089 35.163 91.0859 35.0135 91.3441 34.935C91.6147 34.4789 90.0782 34.5723 90.0658 34.9499Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7444 51.9887C28.4862 52.0672 28.4862 52.0672 28.7444 51.9887C28.0803 52.7513 29.7397 52.8075 29.8875 52.2019C29.8875 52.2019 29.7646 52.0523 30.0227 51.9738C30.2934 51.5177 28.7568 51.6111 28.7444 51.9887Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1244 60.7898C23.8616 60.7771 23.8616 60.7771 24.1244 60.7898C23.0349 61.5281 24.311 62.3808 24.8748 61.6171C24.8748 61.6171 24.8875 61.354 25.1503 61.3667C25.7014 60.8661 24.4127 60.2764 24.1244 60.7898Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8499 22.2192C93.5917 22.2977 93.5917 22.2977 93.8499 22.2192C93.1858 22.9818 94.8453 23.038 94.993 22.4323C94.993 22.4323 94.8701 22.2828 95.1283 22.2043C95.3989 21.7482 93.8624 21.8416 93.8499 22.2192Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7666 64.4466C33.9781 64.4084 33.9272 65.4606 34.7157 65.4988C35.5042 65.5369 35.5551 64.4847 34.7666 64.4466Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7681 30.025C74.7831 29.9773 74.7195 31.2917 75.7045 31.3393C76.6895 31.387 76.7531 30.0726 75.7681 30.025Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4325 71.2408C73.644 71.2026 73.5931 72.2548 74.3816 72.2929C75.1701 72.3311 75.221 71.2789 74.4325 71.2408Z",
    fill: "#E0CAEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0852 48.9264C40.3106 49.1619 40.8021 49.7601 41.5766 49.5246C42.3511 49.2892 41.8597 48.691 41.0852 48.9264Z",
    fill: "#E0CAEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 90,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplanes);
export default __webpack_public_path__ + "static/media/airplanes.789e38285f13525e213dba418ee6d0cf.svg";
export { ForwardRef as ReactComponent };